<template>
  <div class="add-box">
    <div class="add-content">
      <div class="setup_title" style="margin-top: 20px"><i></i>角色属性</div>
      <div class="setup_content">
        <div class="setup_box">
          <div class="setup_lable">角色名称：</div>
          <div class="setup_block">
            <input
              type="text"
              v-model="addParam.modelName"
              value=""
              placeholder="请输入角色名称"
            />
          </div>
        </div>
        <div class="setup_box">
          <div class="setup_lable">角色性别：</div>
          <div class="setup_block">
            <select v-model="addParam.sex" @change="selsex()">
              <option value="">无</option>
              <option value="1">男</option>
              <option value="2">女</option>
            </select>
          </div>
        </div>
        <div class="setup_box">
          <div class="setup_lable">语音音色：</div>
          <div class="setup_block">
            <t9tts :filter-sex="sex" v-bind:ttsrole.sync="ttsrole"></t9tts>
          </div>
        </div>
        <div class="setup_box" style="display: none">
          <div class="setup_lable">角色标签：</div>
          <div class="setup_block">
            <input
              type="text"
              v-model="labelInput"
              value=""
              @keyup.enter="labelEnter"
              placeholder="输入Enter添加"
            />
          </div>
        </div>
        <!-- 标签列表labelList -->
        <div class="label-box" v-if="labelList.length > 0">
          <div v-for="(label, index) in labelList" :key="index" class="label">
            {{ label }}<span @click="delLabel(index)">×</span>
          </div>
        </div>
        <div class="setup_box fengmian">
          <div class="setup_lable">角色封面：</div>
          <div class="setup_block">
            <button @click="jietu">角色截图</button>
            <div class="setup_block" style="position: relative">
              <div
                class="uploader"
                v-if="
                  addParam.rolesPhoto == null || addParam.rolesPhoto.length <= 0
                "
              >
                +
              </div>
              <div
                v-if="
                  addParam.rolesPhoto != null && addParam.rolesPhoto.length > 0
                "
                class="uploader_img"
              >
                <img :src="addParam.rolesPhoto" alt="" />
              </div>
              <div class="defaultupload">
                <fileUpload
                  id="imgupload"
                  accept="jpg,png,gif"
                  typefolder="stageImg"
                  parentfolder="modelcover"
                  @progress="uploadProgress1"
                  @checkfile="checkfile1"
                  @error="uploadError1"
                  @success="uploadSuccess1"
                  style="width: 20px; height: 20px"
                ></fileUpload>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- -----------------角色属性完毕-------------------------------- -->
      <div class="setup_title"><i></i>空闲动画</div>
      <div class="setup_content">
        <div class="dzlist" v-show="anims.length > 0">
          <draggable
            v-model="anims"
            handle=".animname"
            chosen-class="chosen"
            ghost-class="ghost"
          >
            <div class="dzinfo" v-for="(anim, index) in anims" :key="index">
              <div class="animname">
                <i class="iconfont icon-yundongdaka_ticao"></i
                >{{ anim.materialName }}
              </div>
              <div class="animdel" @click="delanim(index)">
                <i class="iconfont icon-remove-1-copy"></i>删除
              </div>
            </div>
          </draggable>
        </div>
        <Material
          :user="user"
          :t9render="t9render"
          @selector="selector"
        ></Material>
      </div>
      <!-- -----------------空闲动画完毕-------------------------------- -->
      <div class="setup_title" v-if="!addParam.parentId"><i></i>使用声明</div>
      <div class="setup_content" v-if="!addParam.parentId">
        <!-- v-if="addParam.rolesSource!=2" -->
        <div class="setup_box">
          <div class="setup_lable">是否公开：</div>
          <div class="setup_block">
            <toggle-switch
              :checked="addParam.rolesOpen == 1"
              @change="rolePublic"
            ></toggle-switch>
          </div>
        </div>

        <div v-if="addParam.rolesOpen == 1">
          <div class="setup_box">
            <div class="setup_lable">角色类型：</div>
            <div class="setup_block">
              <select v-model="addParam.rolesSource">
                <option value="1">原创</option>
                <option value="2">转载</option>
              </select>
            </div>
          </div>
          <div class="setup_box">
            <div class="setup_lable">角色来源：</div>
            <div class="setup_block">
              <input
                type="text"
                v-model="addParam.sourceIntroduction"
                placeholder="请标注模型下载来源"
              />
            </div>
          </div>
          <div class="setup_box">
            <div class="setup_lable">是否允许商用：</div>
            <div class="setup_block">
              <toggle-switch
                :checked="addParam.isCommercial == 1"
                @change="changeIsCommercial"
              ></toggle-switch>
            </div>
          </div>
          <!-- <div class="setup_box">
                        <div class="setup_lable">是否允许二次创作：</div>
                        <div class="setup_block"><toggle-switch :checked="addParam.isCreation==1" @change="changeIsCreation"></toggle-switch></div>
                    </div> -->
          <div class="setup_box">
            <div class="setup_lable">是否允许修改：</div>
            <div class="setup_block">
              <toggle-switch
                :checked="addParam.isModify == 1"
                @change="changeIsModify"
              ></toggle-switch>
            </div>
          </div>
          <!-- <div class="setup_box">
                        <div class="setup_lable">是否允许直播：</div>
                        <div class="setup_block"><toggle-switch :checked="addParam.isLive==1" @change="changeIsLive"></toggle-switch></div>
                    </div> -->
        </div>
      </div>
      <div class="setup_content" @click="saveUser">
        <div class="setup_save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import t9tts from '@/components/t9tts/index.vue'
import Material from '@/views/selector/Material'
import ToggleSwitch from '@/components/v-switch/index.vue'
import { t9oss } from '@/components/util/util.js'
import fileUpload from '@/components/ali_oss/alioss.vue'
import { uploadFile } from '@/components/util/alioss.js'
import draggable from 'vuedraggable'
import { localData } from '../../util/util_fun'

export default {
  data () {
    return {
      //   paramloading: false,
      addParam: { // 回显数据
        modelId: "",
        modelName: "",
        version: "1",
        rolesId: "",
        type: "1",//1龙骨；2、live2d；3、VRM;4、MMD
        sex: "",
        clothesCode: "",
        modelPhoto: "",
        modelJson: "",
        rolesLabel: "",//角色标签
        rolesOpen: 0,//角色是否公开 0.不公开 1.公开
        rolesSource: 2,//角色类型 1.原创 2.转载
        sourceIntroduction: "",//角色来源接受
        isCreation: 0,//是否允许二次创作
        isCommercial: 0,//是否允许商用
        isLive: 0,//是否允许直播
        isModify: 0,//是否允许修改
        isHad: true,//前端使用，是否拥有模型
        uid: this.$store.state.userinfo.userId,
      },
      ttsrole: {},//语音角色
      anims: [], //动画集合
      sex: '', // 1:男2:女
      labelList: [],// 用来存储标签列表 的
      labelInput: "",//标签输入
      progress: 0,// 上传进度
      loglist: [], //上传文件列表
    }
  },
  components: {
    t9tts,
    fileUpload,
    Material,
    ToggleSwitch,
    draggable
  },
  props: {
    user: {
      type: Object,
      default: () => { { } }
    },
    t9render: {
      type: Object,
      default: () => { { } }
    },
  },
  created () {
    console.log('editRole接收的user', this.user)
    //回显基本属性
    this.addParam = JSON.parse(JSON.stringify(this.user))
    this.addParam.modelName = this.user.rolesName
    this.addParam.uid = this.$store.state.userinfo.userId
    this.addParam.rolesOpen = this.user.rolesOpen

    if (this.user.anims) {
      this.anims = JSON.parse(this.user.anims)
    }

    if (this.user.tts) {
      this.ttsrole = JSON.parse(this.user.tts)
    }
    //公开的角色模型，需要回显一下设置项
    this.getPlatformRoles()
    console.log('editRole处理后回显的参数', this.addParam)
  },
  methods: {
    getPlatformRoles () {
      //   this.paramloading = true
      var that = this
      this.post("/platform/getPlatformRoles", { rid: that.user.rolesId }).then((res) => {

        var data = res.data.info
        if (res.status == "200" && data != null) {
          that.addParam.rolesPrice = data.rolesPrice
          that.addParam.rolesSource = data.rolesSource
          that.addParam.sourceIntroduction = data.sourceIntroduction

          if (data.isCreation != null) {
            that.addParam.isCreation = data.isCreation
          }
          if (data.isCommercial != null) {
            that.addParam.isCommercial = data.isCommercial
          }
          if (data.isLive != null) {
            that.addParam.isLive = data.isLive
          }
          if (data.isModify != null) {
            that.addParam.isModify = data.isModify
          }

        }
        // that.paramloading = false
      })
        .catch(() => {
          //   that.paramloading = false
        })
    },
    saveUser () {
      console.log('保存的参数', this.addParam)
      // console.log(this.addParam)
      if (this.addParam.modelName.length <= 0) {
        this.$message.warning("需要先给角色起一个名字！")
        return
      }
      if (this.addParam.modelJson.length <= 0) {
        this.$message.warning("您未上传改角色的模型文件！")
        return
      }

      this.addParam.anims = JSON.stringify(this.anims)//空闲动画
      this.addParam.tts = JSON.stringify(this.ttsrole)//语音合成
      this.$message.warning('保存中...')

      if (this.labelInput.length > 0) {
        this.labelList.push(this.labelInput)
      }
      this.addParam.rolesLabel = JSON.stringify(this.labelList)
      this.addParam.rolesName = this.addParam.modelName
      this.post("/roles/editModel", this.addParam).then((res) => {
        this.loading = false
        if (res.status == "200") {
          this.$message.success("保存成功")
          // console.log('父组件回调的参数addparam', this.addParam)
          this.$emit('updataRole', this.addParam)
          let userobj = {
            resid: this.addParam.rolesId,
            resname: this.addParam.rolesName,
            resobj: this.addParam,
            resimg: this.addParam.rolesPhoto,//资源封面 
            restype: 1,
            startend: [0, 0],
            timeline: []
          }
          // 在这里把最新的数据回显到渲染器中
          let videoNew = localData('get', 'videoobj-new')
          let ttsNew = localData('get', 'ttslist-new')
          if (videoNew) {
            let index = videoNew.scenes[0].res.findIndex((item) => item.restype == 1)
            if (index != -1) {
              if (videoNew.scenes[0].res[index].resid == userobj.resid) {
                videoNew.scenes[0].res[index].resname = this.addParam.rolesName
                videoNew.scenes[0].res[index].resobj = this.addParam
                videoNew.scenes[0].res[index].resimg = this.addParam.rolesPhoto
                localData('set', 'videoobj-new', videoNew)
              }
            }
          }
          if (ttsNew) {
            let index = ttsNew.scenes[0].res.findIndex((item) => item.restype == 1)
            if (index != -1) {
              if (ttsNew.scenes[0].res[index].resid == userobj.resid) {
                ttsNew.scenes[0].res[index].resname = this.addParam.rolesName
                ttsNew.scenes[0].res[index].resobj = this.addParam
                ttsNew.scenes[0].res[index].resimg = this.addParam.rolesPhoto
                localData('set', 'ttslist-new', ttsNew)
              }
            }
          }
          //   this.$emit('success', this.addParam)
        } else {
          //   this.saveMsg = "保存失败"
          this.$message.error('保存失败')
        }
      })
        .catch((fail) => {
          this.$message.error('保存失败')

        })
    },
    //选择性别
    selsex () {
      var xb = this.addParam.sex
      if (xb == "1") {
        this.sex = "男"
      }
      else if (xb == "2") {
        this.sex = "女"
      }
      else {
        this.sex = null
      }
    },
    jietu () {
      t9render.screenshot((base64) => {
        this.uploadCover(this.dataURLtoBlob(base64))
      })
    },
    /*****************封面的上传*******************/
    //上传成功！
    uploadSuccess1 (json) {
      console.log(json)

      if (json.fileDir.length <= 0) {
        // this.putLog("上传文件不可用，请检查该文件是否为live2d压缩包！")
        this.$message.error('截图失败')
      } else {
        this.$message.success("上传成功")
        // this.params.modelName=json.fileName.split(".")[0];
        // (json.fileUrl).split('?')[0])
        this.addParam.modelPhoto = (json.fileUrl).split('?')[0]
        this.addParam.rolesPhoto = (json.fileUrl).split('?')[0]

      }

    },
    //上传失败
    uploadError1 (err) {
      //   this.uploadloading = false
      this.$message.error("上传失败！")

    },
    uploadCover (blob) {
      var that = this
      var path = JSON.parse(this.addParam.modelJson).fileDir
      var pathpart = path.split("/")

      //得到随机字符串的目录  model_xxxxxx
      pathpart.splice(pathpart.length - 2, 2)
      var newurl = pathpart.join("/")

      var name = newurl + "/model_cover_" + new Date().getTime() + ".png"
      uploadFile(name, blob, function (progress) {
        // 上传进度
        console.log("封面上传进度：" + progress)
      }, function (results) {
        //这里暂时把地址写死了，以后记得改到配置文件
        var url = t9oss + '/' + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
        console.log("封面上传成功：" + url)
        that.addParam.modelPhoto = url
        that.addParam.rolesPhoto = url
        that.addParam = Object.assign([], that.addParam)
        // console.log(results.res.requestUrls[0]);
        // that.saveCenter();
      }, function (err) {
        console.log("封面上传失败！" + err)
        // that.saveCenter();
      })
    },
    //base64转blob
    dataURLtoBlob (dataurl) {
      var arr = dataurl.split(',')
      //注意base64的最后面中括号和引号是不转译的   
      var _arr = arr[1].substring(0, arr[1].length - 2)
      var mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(_arr),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    //进度条
    uploadProgress1 (p) {
      this.progress = p
    },
    //文件选择成功
    checkfile1 (file) {
      this.loglist = []
      //   this.uploadloading = true
    },
    /*****************空闲动画的设置*******************/
    //动作选择
    selector (obj) {
      // console.log('选择内容',obj);
      this.anims.push(obj)
    },
    delanim (index) {
      this.anims.splice(index, 1)
    },
    /*****************使用声明的设置*******************/
    //是否允许商用
    changeIsCommercial (data) {
      if (this.addParam.isCommercial == 0) {
        this.addParam.isCommercial = 1
      } else {
        this.addParam.isCommercial = 0
      }
    },
    //是否允许二次创作
    changeIsCreation (data) {
      if (this.addParam.isCreation == 0) {
        this.addParam.isCreation = 1
      } else {
        this.addParam.isCreation = 0
      }
    },
    //是否允许直播
    changeIsLive (data) {
      if (this.addParam.isLive == 0) {
        this.addParam.isLive = 1
      } else {
        this.addParam.isLive = 0
      }
    },
    //是否允许修改
    changeIsModify (data) {
      if (this.addParam.isModify == 0) {
        this.addParam.isModify = 1
      } else {
        this.addParam.isModify = 0
      }
    },
    //是否公开
    rolePublic () {
      if (this.addParam.rolesOpen == 0) {
        this.addParam.rolesOpen = 1
      } else {
        this.addParam.rolesOpen = 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dzlist {
  border: 1px #ddd solid;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;

  .dzinfo {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    font-size: 14px;
    border-bottom: 1px #ddd solid;
    margin-bottom: 3px;

    .animname {
      cursor: move;
    }
    .animdel {
      cursor: pointer;
    }
    i {
      color: #39f;
      font-size: 16px !important;
    }
  }
}
.setup_save {
  height: 44px;
  width: 40%;
  background: #e0a2aa;
  text-align: center;
  line-height: 44px;
  margin: 0 auto;
  border-radius: 44px;
  &:hover {
    background: #e58993;
  }
}
</style>